'use strict';

module.exports.AddressPredictor = require('./address.predictor');
module.exports.DateTimePredictor = require('./datetime.predictor');
module.exports.EmailPredictor = require('./email.predictor');
module.exports.BooleanPredictor = require('./boolean.predictor');
module.exports.ImagePredictor = require('./image.predictor');
module.exports.LinkPredictor = require('./link.predictor');
module.exports.RichTextPredictor = require('./richtext.predictor');
module.exports.PhonePredictor = require('./phone.predictor');
module.exports.NumberPredictor = require('./number.predictor');
module.exports.CurrencyPredictor = require('./currency.predictor');
module.exports.PercentagesPredictor = require('./percentage.predictor');